"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupsFromFolder = exports.appendNewFolderToParent = exports.appendAssetsToFolder = exports.loadMoreAssetsAndSubFoldersToFolder = exports.includeResourcesOnFolder = void 0;
function includeResourcesOnFolder(state, payload) {
    /**
     * It needs to find the folder recursively based on state.navigation and include the resources
     * on the folder that matches the payload.folderId
     */
    const mapFolder = (folders, payload, navigationIndex = 0) => {
        return folders.map((folder) => {
            var _a;
            if (folder.id === state.navigation[navigationIndex]) {
                return Object.assign(Object.assign({}, folder), { folders: mapFolder((_a = folder.folders) !== null && _a !== void 0 ? _a : [], payload, navigationIndex + 1) });
            }
            if (folder.id === payload.folderId) {
                return Object.assign(Object.assign({}, folder), { folders: payload.folders, assets: payload.assets });
            }
            return folder;
        });
    };
    return mapFolder(state.folders, payload);
}
exports.includeResourcesOnFolder = includeResourcesOnFolder;
function loadMoreAssetsAndSubFoldersToFolder(state, payload) {
    const mapFolder = (folders) => {
        return folders.map((folder) => {
            var _a, _b;
            if (folder.id === payload.folderId) {
                return Object.assign(Object.assign({}, folder), { folders: [...((_a = folder.folders) !== null && _a !== void 0 ? _a : []), ...payload.folders], assets: [...folder.assets, ...payload.assets] });
            }
            return Object.assign(Object.assign({}, folder), { folders: mapFolder((_b = folder.folders) !== null && _b !== void 0 ? _b : []) });
        });
    };
    return Object.assign(Object.assign({}, state), { folders: mapFolder(state.folders) });
}
exports.loadMoreAssetsAndSubFoldersToFolder = loadMoreAssetsAndSubFoldersToFolder;
function appendAssetsToFolder(state, payload) {
    if (!payload.folderId) {
        return Object.assign(Object.assign({}, state), { assets: [...payload.assets, ...state.assets] });
    }
    const mapFolder = (folders, payload, navigationIndex = 0) => {
        // Base case
        if (navigationIndex === state.navigation.length) {
            return folders.map((folder) => {
                if (folder.id === payload.folderId) {
                    return Object.assign(Object.assign({}, folder), { assets: [...payload.assets, ...folder.assets] });
                }
                return folder;
            });
        }
        // Recursive case
        return folders.map((folder) => {
            var _a;
            if (payload.folderId === folder.id) {
                return Object.assign(Object.assign({}, folder), { assets: [...payload.assets, ...folder.assets] });
            }
            return Object.assign(Object.assign({}, folder), { folders: mapFolder((_a = folder.folders) !== null && _a !== void 0 ? _a : [], payload, navigationIndex + 1) });
        });
    };
    return Object.assign(Object.assign({}, state), { folders: mapFolder(state.folders, payload) });
}
exports.appendAssetsToFolder = appendAssetsToFolder;
function appendNewFolderToParent(state, payload) {
    var _a;
    if (!payload.parent) {
        return Object.assign(Object.assign({}, state), { folders: [
                {
                    id: payload.folderId,
                    name: payload.name,
                    subTitle: '',
                    assets: [],
                    folders: [],
                    groups: (_a = payload === null || payload === void 0 ? void 0 : payload.groups) !== null && _a !== void 0 ? _a : [],
                },
                ...state.folders,
            ] });
    }
    const mapFolder = (folders, payload, navigationIndex = 0) => {
        // Base case
        if (navigationIndex === state.navigation.length) {
            return folders.map((folder) => {
                var _a, _b;
                if (folder.id === payload.parent) {
                    return Object.assign(Object.assign({}, folder), { folders: [
                            {
                                id: payload.folderId,
                                name: payload.name,
                                subTitle: '',
                                assets: [],
                                folders: [],
                                groups: (_a = payload === null || payload === void 0 ? void 0 : payload.groups) !== null && _a !== void 0 ? _a : [],
                            },
                            ...((_b = folder.folders) !== null && _b !== void 0 ? _b : []),
                        ] });
                }
                return folder;
            });
        }
        // Recursive case
        return folders.map((folder) => {
            var _a, _b, _c;
            if (payload.parent === folder.id) {
                return Object.assign(Object.assign({}, folder), { folders: [
                        {
                            id: payload.folderId,
                            name: payload.name,
                            subTitle: '',
                            assets: [],
                            folders: [],
                            groups: (_a = payload === null || payload === void 0 ? void 0 : payload.groups) !== null && _a !== void 0 ? _a : [],
                        },
                        ...((_b = folder.folders) !== null && _b !== void 0 ? _b : []),
                    ] });
            }
            return Object.assign(Object.assign({}, folder), { folders: mapFolder((_c = folder.folders) !== null && _c !== void 0 ? _c : [], payload, navigationIndex + 1) });
        });
    };
    return Object.assign(Object.assign({}, state), { folders: mapFolder(state.folders, payload) });
}
exports.appendNewFolderToParent = appendNewFolderToParent;
function getGroupsFromFolder(state, folderId) {
    const mapFolder = (folders, folderId, navigationIndex = 0) => {
        // Base case
        if (navigationIndex === state.navigation.length) {
            return folders.reduce((acc, folder) => {
                var _a;
                if (folder.id === folderId) {
                    return (_a = folder.groups) !== null && _a !== void 0 ? _a : [];
                }
                return acc;
            }, []);
        }
        // Recursive case
        return folders.reduce((acc, folder) => {
            var _a, _b;
            if (folder.id === folderId) {
                return (_a = folder.groups) !== null && _a !== void 0 ? _a : [];
            }
            return acc.concat(mapFolder((_b = folder.folders) !== null && _b !== void 0 ? _b : [], folderId, navigationIndex + 1));
        }, []);
    };
    return mapFolder(state.folders, folderId);
}
exports.getGroupsFromFolder = getGroupsFromFolder;
//# sourceMappingURL=workspace.utils.js.map